import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiprintDeviceComponent } from './components/multiprint-device/multiprint-device.component';
import { MultiprintComponent } from './components/multiprint/multiprint.component';
import { SharedModule } from '@shared/shared.module';
import { MultiPrintMaterialsPipe } from './pipes/multi-print-materials.pipe';
import { NbStepperModule } from '@nebular/theme';
import { MultiprintFirstStepComponent } from './components/multiprint-first-step/multiprint-first-step.component';
import { MultiprintSecondStepComponent } from './components/multiprint-second-step/multiprint-second-step.component';
import { MultiprintThirdStepComponent } from './components/multiprint-third-step/multiprint-third-step.component';
import { MultiprintOnlyDevicesPipe } from './pipes/multiprint-only-devices.pipe';
import { MultiPrintDeviceMaterialFilterPipe } from './pipes/multi-print-device-material-filter.pipe';
import { MultiPrintDeviceStatusFilterPipe } from './pipes/multi-print-device-status-filter.pipe';
import { MultiPrintDeviceStatusSortPipe } from './pipes/multi-print-device-status-sort.pipe';
import { PrintFileSharedModule } from '@shared/modules/print-file-shared/print-file-shared.module';
import { AccountSharedModule } from '@shared/modules/account/account-shared.module';
import { DeviceSharedModule } from '@shared/modules/device/device-shared.module';



@NgModule({
  declarations: [
    MultiprintDeviceComponent,
    MultiprintComponent,
    MultiPrintMaterialsPipe,
    MultiprintFirstStepComponent,
    MultiprintSecondStepComponent,
    MultiprintThirdStepComponent,
    MultiprintOnlyDevicesPipe,
    MultiPrintDeviceMaterialFilterPipe,
    MultiPrintDeviceStatusFilterPipe,
    MultiPrintDeviceStatusSortPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    PrintFileSharedModule,
    AccountSharedModule,
    DeviceSharedModule,
    NbStepperModule
  ]
})
export class MultiprintModule { }
